import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'itl-detail-title-icon',
  template: '<ng-content></ng-content>',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DetailTitleIconComponent {}
